"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const auth_1 = require("../auth");
const Workflow_1 = require("./Workflow");
const WorkflowRunAction_1 = require("./WorkflowRunAction");
const FAILURE_REASONS = [
    '',
    'No subject line is specified',
    'The proof schedule was not saved properly',
    'No email service provider is specified',
    'Failed to create campaign',
    'No email specified',
    'No list ID specified',
    'No campaign from email address specified',
    'No campaign from name specified',
];
let WorkflowRun = class WorkflowRun extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], WorkflowRun.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], WorkflowRun.prototype, "ranByUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User, {
        nullable: true,
    }),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], WorkflowRun.prototype, "proofSentByUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: 'scheduled' }),
    class_validator_1.IsIn([
        'scheduled',
        'running',
        'proofSentNoApprovalNeeded',
        'pendingApproval',
        'cancelled',
        'paused',
        'succeeded',
        'failed',
    ]),
    tslib_1.__metadata("design:type", String)
], WorkflowRun.prototype, "status", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Workflow_1.Workflow),
    typeorm_1.ManyToOne(() => Workflow_1.Workflow, workflow => workflow.runs, {
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], WorkflowRun.prototype, "workflow", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.RelationId((obj) => obj.workflow),
    tslib_1.__metadata("design:type", Number)
], WorkflowRun.prototype, "workflowId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [WorkflowRunAction_1.WorkflowRunAction]),
    typeorm_1.OneToMany(() => WorkflowRunAction_1.WorkflowRunAction, workflowRunAction => workflowRunAction.workflowRun),
    tslib_1.__metadata("design:type", Object)
], WorkflowRun.prototype, "actions", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Workflow_1.Workflow, { nullable: true }),
    typeorm_1.OneToOne(() => Workflow_1.Workflow, workflow => workflow.metaForWorkflowRun, {
        nullable: true,
        onDelete: 'CASCADE',
    }),
    typeorm_1.JoinColumn({ name: 'workflowMetaId' }),
    tslib_1.__metadata("design:type", Object)
], WorkflowRun.prototype, "workflowMeta", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'timestamp',
    }),
    tslib_1.__metadata("design:type", String)
], WorkflowRun.prototype, "runDateTime", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'timestamp',
    }),
    tslib_1.__metadata("design:type", String)
], WorkflowRun.prototype, "originalRunDateTime", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'timestamp',
    }),
    tslib_1.__metadata("design:type", Date)
], WorkflowRun.prototype, "proofSendDateTime", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({
        default: false,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Boolean)
], WorkflowRun.prototype, "edited", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({
        default: false,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Boolean)
], WorkflowRun.prototype, "forceRan", void 0);
tslib_1.__decorate([
    type_graphql_1.Field({ nullable: true }),
    typeorm_1.Column({ default: '' }),
    class_validator_1.IsIn(FAILURE_REASONS),
    tslib_1.__metadata("design:type", String)
], WorkflowRun.prototype, "failureReason", void 0);
WorkflowRun = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity(),
    typeorm_1.Unique(['workflow', 'runDateTime'])
], WorkflowRun);
exports.WorkflowRun = WorkflowRun;
class WorkflowRunEntity extends WorkflowRun {
    toString() {
        return `Workflow run #${this.id}`;
    }
}
exports.WorkflowRunEntity = WorkflowRunEntity;
//# sourceMappingURL=WorkflowRun.js.map